// EN
export const hotelRoomsManager = {
  header: {
    eyebrow: "Quartos de hotel",
    title: "Gestão de quartos",
    subtitle:
      "Crie tipos de quarto e gere as unidades físicas com sua numeração. Esses quartos serão sincronizados com o Channex.",
    addRoom: "Adicionar quarto",
  },
  states: {
    loading: "Carregando quartos...",
    emptyTitle: "Ainda não há quartos",
    emptySubtitle:
      "Crie o primeiro tipo de quarto para começar a configurar tarifas e disponibilidade no Channex.",
    addFirstRoom: "Adicionar primeiro quarto",
  },
  card: {
    roomsBadge: "{count} quarto | {count} quartos",
    maxGuests: "Máx. {count} hóspedes",
    editTitle: "Editar quarto",
    deleteTitle: "Excluir quarto",
    adults: "{count} adulto | {count} adultos",
    children: "{count} criança | {count} crianças",
    infants: "{count} bebê | {count} bebês",
    units: "Unidades",
  },
  physical: {
    title: "Quartos físicos",
    subtitle:
      "Edite o número ou o nome de cada quarto, ou mova-o para outro tipo. As reservas vão junto. Arraste-os pela alça para ordená-los dentro do seu tipo: essa é a ordem que você verá no calendário.",
    roomsCount: "{count} quarto | {count} quartos",
    savingOrder: "Salvando ordem…",
    selectAll: "Selecionar tudo",
    clearSelection: "Limpar seleção",
    dragToOrder: "Arraste para reordenar",
    selectRoom: "Selecionar {label}",
    roomFallback: "quarto",
    codePlaceholder: "Nº / código",
    namePlaceholder: "Nome",
  },
  bar: {
    selectedCount: "quarto selecionado | quartos selecionados",
    clearSelection: "Limpar seleção",
    changeType: "Mudar tipo",
  },
  modal: {
    createTitle: "Novo quarto",
    editTitle: "Editar quarto",
    createSubtitle: "Defina o tipo e gere as unidades físicas",
    editSubtitle: "Atualize os detalhes do tipo de quarto",
    basicInfo: "Informações básicas",
    nameLabel: "Nome do quarto",
    namePlaceholder: "Ex.: Quarto Duplo, Suíte Júnior…",
    descriptionLabel: "Descrição",
    optional: "(opcional)",
    descriptionPlaceholder: "Vista para o mar, terraço, frigobar…",
    inventorySection: "Estoque e capacidade",
    countLabel: "Número de quartos",
    countHintZero:
      "Criado sem quartos: depois você pode atribuir quartos existentes a ele na lista de quartos físicos.",
    countHint: "Total de unidades físicas deste tipo",
    capacityLabel: "Capacidade total (hóspedes)",
    capacityHint: "Máximo permitido entre adultos + crianças + bebês",
    priceLabel: "Preço por noite",
    priceHint:
      "Isso cria a tarifa padrão. Você pode ajustá-la depois em “Tarifas de hotel”.",
    adultsLabel: "Adultos",
    childrenLabel: "Crianças",
    infantsLabel: "Bebês",
    numberingSection: "Numeração dos quartos",
    toggleOn: "Ativado",
    toggleOff: "Desativado",
    numberingHintCreate:
      "Os quartos são criados com um código automático. Você pode alterá-lo um a um na lista de quartos físicos, ou definir a numeração em “Editar” para que os próximos já nasçam com ela.",
    prefixLabel: "Prefixo do código",
    prefixPlaceholder: "Ex.: 10  ou  A-",
    prefixHint: 'Ex.: prefixo "10" + início 1 → 101, 102…',
    startNumberLabel: "Número inicial",
    paddingLabel: "Zeros à esquerda",
    paddingHint: "3 → 001, 002…",
    nameModeLabel: "Nomes dos quartos físicos",
    nameModeType: "Somente tipo",
    nameModeTypeExample: "Duplo",
    nameModeTypeCode: "Tipo + código",
    nameModeTypeCodeExample: "Duplo 101",
    preview: {
      lead: "Vamos criar",
      roomsNoun: "quarto | quartos",
      withNumbering: "com esta numeração. Exemplo:",
    },
    numberingHintKeep:
      "Os quartos existentes mantêm seu número. Esta numeração se aplicará aos que você adicionar a partir de agora.",
    numberingHintZero:
      "Sem quartos, não há nada para numerar. Atribua quartos existentes a ele na lista de quartos físicos.",
    numberingHintDisabled:
      "Os quartos físicos não serão gerados automaticamente. Você pode ativar isso quando quiser.",
    cancel: "Cancelar",
    saving: "Salvando…",
    creating: "Criando…",
    saveChanges: "Salvar alterações",
    createRoom: "Criar quarto",
  },
  delete: {
    title: "Excluir quarto",
    subtitle: "Esta ação não pode ser desfeita",
    confirmCopy: "Digite o nome do quarto para confirmar:",
    placeholder: "Nome do quarto",
    cancel: "Cancelar",
    deleting: "Excluindo...",
    confirm: "Excluir",
  },
  change: {
    title: "Mudar o tipo {target}",
    subtitle: "O número do quarto não muda",
    newTypeLabel: "Novo tipo",
    newTypePlaceholder: "Escolha para qual tipo ele será movido…",
    blocksHead: "Uma reserva está bloqueando a mudança | {count} reservas estão bloqueando a mudança",
    moves: "Move para o novo tipo",
    stays: "Permanece no tipo atual",
    addMissing: "Adicione {labels} à mudança e tente novamente",
    stockLabel: "Quartos à venda",
    checkingReservations: "Verificando quais reservas estão em {target}…",
    thisRoom: "este quarto",
    theseRooms: "estes quartos",
    theRoom: "o quarto",
    theRooms: "os quartos",
    noReservations: "Não há reservas em {target}.",
    reservationsLeave: "reserva sai | reservas saem",
    with: "com {target}",
    moreReservations: "e mais {count} reserva | e mais {count} reservas",
    greyLegend: "Os quartos em cinza permanecem no tipo atual.",
    retry: "Tentar novamente",
    cancel: "Cancelar",
    applying: "Alterando…",
    confirm: "Sim, mudar tipo",
    titleTargetOne: "do quarto {label}",
    titleTargetMany: "de {count} quarto | de {count} quartos",
    textZero: "Estes quartos já são desse tipo: escolha outro para movê-los.",
    textOne:
      "O quarto mantém seu número e suas reservas: muda apenas o tipo como o qual é vendido. Onde ele está agora haverá um quarto a menos à venda, e no novo tipo, um a mais.",
    textMany:
      "Os {count} quartos mantêm seu número e suas reservas: muda apenas o tipo como o qual são vendidos. Onde eles estão agora haverá {count} quartos a menos à venda, e no novo tipo, {count} a mais.",
  },
  blockTitles: {
    huespedDentro: "Um hóspede fez check-in",
    reservaRepartida: "A reserva ocupa outros quartos",
    reservaSinAsignar: "A reserva está sem alguns de seus quartos",
    fallback: "Não pode ser movido",
  },
  groups: {
    noType: "Nenhum tipo atribuído",
  },
  reservation: {
    noName: "Sem nome",
  },
  toasts: {
    roomsChanged: "Quarto mudou de tipo | {count} quartos mudaram de tipo",
    changedSyncing: "{done} · atualizando canais",
    created: "Quarto criado com sucesso",
    updated: "Quarto atualizado",
    deleted: "Quarto excluído",
  },
  errors: {
    generic: "Algo deu errado.",
    loadRooms: "Erro ao carregar os quartos",
    updateQty: "Não foi possível atualizar a quantidade",
    savePhysicalRoom: "Não foi possível salvar o quarto",
    saveOrder: "Não foi possível salvar a ordem dos quartos.",
    checkReservations: "Não foi possível verificar quais reservas estão nestes quartos.",
    changeType: "Não foi possível mudar o tipo do quarto.",
    noProperty: "Não foi possível obter a acomodação. Tente novamente.",
    saveRoom: "Erro ao salvar o quarto",
    deleteRoom: "Erro ao excluir",
  },
};
